import React from 'react'
import Project from '../../components/Project'
import buenbitDesktopImage from '../../media/clients/buenbit-desktop-project.webp'
import { SOFTWARE_SERVICES_PATH } from '../../routes'
import { otherProjectsWithout } from '../otherProjectsCardsInformation'

export default class BuenbitProject extends React.Component {
    name(){
        return 'buenbit'
    }

    service(){
        return 'softwareDevelopment'
    }

    texts() {
        return this.props.texts
    }

    image() {
        return this.props.image
    }

    solutionsTexts() {
        return this.texts()['solutions']
    }

    otherProjects() {
        return otherProjectsWithout(this.name(),
            this.service(), this.solutionsTexts())
    }

    render() {
        return (
            <Project
                texts={this.texts()}
                image={this.image()}
                projectImg={buenbitDesktopImage}
                otherProjects={this.otherProjects()}
                projectAreaPath={SOFTWARE_SERVICES_PATH}
            />
        )
    }
}
